/**
 * Overlay Style Utilities
 *
 * Shared styles for overlay components (Dialog, Sheet, AlertDialog).
 * These components all share the same overlay pattern with fade animation.
 */

/**
 * Fade animation for overlays
 * Used for open/close transitions
 */
export const OVERLAY_FADE_ANIMATION =
  'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';

/**
 * Full screen overlay base styles
 * Covers the entire viewport with semi-transparent background
 */
export const OVERLAY_FULL = `${OVERLAY_FADE_ANIMATION} fixed inset-0 z-50 bg-black/50`;
